/**
 * Ét sandhedsgrundlag for Votras adresser (NAP).
 *
 * Bruges af JSON-LD, adressesiden og kursussiderne, så Google og AI-systemer aldrig
 * møder modstridende oplysninger om hvor Votra er, og hvad der er partnerens lokaler.
 * Skovlunde og Højbjerg er UCplus' adresser — Votra underviser der, men det er IKKE
 * Votras egne forretningsadresser og må derfor ikke udstilles som Votra-LocalBusiness.
 */

export const CONTACT = {
  phone: "+4555292828",
  phoneDisplay: "+45 55 29 28 28",
  email: "kundeservice@votra.dk",
  legalName: "Votra Danmark ApS",
  brandName: "Votra Vognmandsuddannelser",
  // CVR for uddannelsesselskabet. Må ikke forveksles med Votra Business ApS
  // (CVR 46818296), der har sit eget Organization-schema i data/business/profile.js.
  cvr: "36486899",
  vatId: "DK36486899",
};

export const VOTRA_LOCATIONS = [
  {
    id: "soeborg-transformervej",
    name: "Votra Danmark ApS, Søborg (hovedkontor)",
    street: "Transformervej 14",
    postalCode: "2860",
    city: "Søborg",
    hq: true,
    teaching: true,
    examVenue: true,
    pageSlug: "soeborg",
    hash: "#votra-soborg-transformervej",
  },
  {
    id: "ringsted",
    name: "Votra Danmark ApS, Ringsted",
    street: "Sct. Hansgade 9, 2. sal",
    postalCode: "4100",
    city: "Ringsted",
    teaching: true,
    examVenue: true,
    pageSlug: "ringsted",
    hash: "#votra-ringsted",
  },
  {
    id: "soeborg-vandtaarnsvej",
    name: "Votra Danmark ApS, Søborg (Vandtårnsvej)",
    street: "Vandtårnsvej 77",
    postalCode: "2860",
    city: "Søborg",
    teaching: true,
    examVenue: true,
    pageSlug: "soeborg",
    hash: "#votra-soborg-vandtaarnsvej",
  },
];

export const PARTNER_VENUES = [
  {
    id: "skovlunde",
    name: "UCplus Skovlunde",
    street: "Mileparken 12A",
    postalCode: "2740",
    city: "Skovlunde",
    partner: "UCplus",
  },
  {
    id: "hoejbjerg",
    name: "UCplus Højbjerg (Aarhus)",
    street: "Øster Parkvej 15",
    postalCode: "8270",
    city: "Højbjerg",
    partner: "UCplus",
  },
];

export const HQ = VOTRA_LOCATIONS[0];

/** Matcher den frie lokationstekst på et hold (fx "Ringsted", "Skovlunde (Mileparken)"). */
export const resolveVenue = (text) => {
  const t = (text || "").toLowerCase();
  return (
    VOTRA_LOCATIONS.find((l) => t.includes(l.city.toLowerCase()) || t.includes(l.id.split("-")[0])) ||
    PARTNER_VENUES.find((p) => t.includes(p.city.toLowerCase())) ||
    null
  );
};

export const postalAddress = (l) => ({
  "@type": "PostalAddress",
  streetAddress: l.street,
  postalCode: l.postalCode,
  addressLocality: l.city,
  addressCountry: "DK",
});
